import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useEffect, useMemo, useState } from 'react';
import { Box, Chip, Grid, Group, GroupGutter, Icon, IconColor, IconName, Label, LabelSize, Text, TextColor, TextSize, } from '@as/cotopaxi';
import { BasketButtonError } from '@as-react/common-types';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { PRODUCT_SIZE_CHIP_INNER_PADDING } from '../../../constants/ProductConstants';
import { ScrollUtil } from '../../../util/ScrollUtil';
import { getSizeButtonsError } from '../../../util/ProductUtil';
export const SizeSelectButtonsFull = ({ id, selectedSku, selectSize, isNotifyMeSizeError, options, filteredSizes, basketValidationState, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const selectedSize = selectedSku && filteredSizes.find(option => option.sku === selectedSku);
    const [errorMessage, setErrorMessage] = useState();
    const chipSize = `${Math.max(...options.map(s => s.label.toString().length))}ch + ${PRODUCT_SIZE_CHIP_INNER_PADDING}px`;
    useEffect(() => {
        if (basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT ||
            basketValidationState === BasketButtonError.SKU ||
            isNotifyMeSizeError) {
            ScrollUtil.scrollToErrorElement(document.getElementById(id), isDesktop, () => {
                setErrorMessage(getSizeButtonsError(basketValidationState));
            });
        }
    }, [basketValidationState]);
    const getButtonState = (option) => {
        if (option.disabled)
            return 'disabled';
        if (errorMessage && (!option.isSoldOut || (option.isSoldOut && isNotifyMeSizeError)))
            return 'error';
        if (option.value === selectedSku)
            return 'activated';
        return 'enabled';
    };
    const handleButtonClick = (option) => () => {
        if (option.disabled)
            return;
        setErrorMessage(undefined);
        selectSize({ sku: option.value.toString(), isSoldOut: option.isSoldOut });
    };
    const buttonOptions = useMemo(() => options.map(option => (_jsx(Chip, { state: getButtonState(option), text: option.isSoldOut ? (_jsx(Text, { inline: true, strike: true, size: TextSize.INHERIT, children: option.label })) : (option.label), onClick: option.disabled ? undefined : handleButtonClick(option), noInlinePadding: true }, option.value.toString()))), [options]);
    return (_jsxs(Box, { id: id, dataAttributes: { 'data-qa': id }, children: [selectedSize &&
                selectedSize.fullCommercialSize &&
                !options.find(size => size.label === selectedSize.fullCommercialSize) ? (_jsxs(Group, { inline: true, gutterX: GroupGutter.SMALL, children: [_jsx(Label, { size: LabelSize.MINOR, emphasized: true, children: t('pdp.size.buttons.label') }), _jsx(Text, { inline: true, children: selectedSize.fullCommercialSize })] })) : (_jsx(Label, { size: LabelSize.MINOR, emphasized: true, children: t('pdp.size.buttons.label') })), _jsx(Box, { mobile: { spacing: { marginBottom: 1, marginTop: 1 } }, children: _jsx(Grid, { scalable: {
                        min: `calc(${chipSize})`,
                        maxCols: options.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 6 },
                        repeatPattern: options.length <= 2 ? 'auto-fill' : undefined,
                    }, gap: "s", dataQA: "size-select-buttons", children: buttonOptions }) }), errorMessage && (_jsxs(Group, { inline: true, children: [_jsx(Icon, { name: IconName.INFORMATION_OUTLINE, color: IconColor.NEGATIVE }), ' ', _jsx(Text, { inline: true, color: TextColor.NEGATIVE, children: t(errorMessage) })] }))] }));
};
